import { extractQueryState } from "@shared/utils/extractQueryState";
import { useInfiniteQuery } from "@tanstack/react-query";
import { getChatLogsApiClient } from "@shared/apis/sidekick/api-factories";
import { useState } from "react";

type Props = {
  userId: string;
  enabled?: boolean;
};

const buildAdminGetUserThreadsKey = (params: Props) => {
  const { userId } = params;
  return ["admin-user-threads", { userId }];
};

export const useAdminGetUserThreads = (props: Props) => {
  const { userId, enabled = true } = props;
  const [totalPages, setTotalPages] = useState<number | null>(null);
  const chatApi = getChatLogsApiClient();
  const query = useInfiniteQuery({
    queryKey: buildAdminGetUserThreadsKey(props),
    queryFn: async ({ pageParam }) => {
      try {
        const response = await chatApi.chatLogsControllerThreads({
          userId,
          orphans: false,
          limit: 20,
          page: pageParam,
        });
        const { total, limit } = response;
        setTotalPages(Math.ceil(total / limit));
        return response;
      } catch (error) {
        console.error("Failed to get user threads.", error);
        throw error;
      }
    },
    initialPageParam: 1,
    getNextPageParam: (lastPage) => {
      if (!totalPages) return undefined;
      return lastPage.page < totalPages ? lastPage.page + 1 : undefined;
    },
    enabled,
    retry: false,
    refetchInterval: false,
    refetchOnWindowFocus: false,
  });

  return extractQueryState(query);
};
